import React from 'react';
import {Chip} from "@mui/material";

function AgenceBadge({agence, size = 'small'}) {
	if (!agence) return '—';
	return (
		<Chip
			label={agence.libelle}
			size={size}
			sx={{
				backgroundColor: agence.codeCouleur,
				color: 'white',
				fontWeight: 600,
			}}
		/>
	);
}

export default AgenceBadge;
